import React, { useEffect, useState } from 'react';
import { GetPayPalOrderDetailsApi } from '../../../api/request/wallet/deposit';
import { useNavigate, useParams } from 'react-router-dom';
import { Spin } from 'antd';

const PaymentVerify = () => {
  const navigate = useNavigate();
  const { CRM_OrderId } = useParams();
  const [isLoading, setIsLoading] = useState(true);
  const [orderDetails, setOrderDetails] = useState([]);
  const orderId = CRM_OrderId?.replace("CRM_OrderId=", "");
  const getOrderDetails = async () => {
    try {
      setIsLoading(true);
      const { data } = await GetPayPalOrderDetailsApi(orderId);
      if (data?.success) {
        setOrderDetails(data?.data);
      }
    } catch (error) { }
    finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (orderId) getOrderDetails();
  }, [orderId]);

  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] text-center px-4">
      {isLoading ? (<Spin size="large" />) :
        orderDetails?.status === "COMPLETED" ? (
          <>
            <img src="/assets/success.gif" alt="success" className="h-48" />
            <h1 className="text-2xl font-semibold text-green-600"> Payment Successful! </h1>
            <p className="mt-2 text-gray-600"> Your transaction has been completed successfully. </p>
            <div className="mt-6 p-4 sm:w-1/2 w-full text-left bg-green-50 rounded-xl shadow">
              <ul className="text-gray-700 space-y-1">
                <li><b>Transaction ID:</b> {orderDetails?.payPalOrderId}</li>
                <li><b>Amount:</b> ${orderDetails?.amount}</li>
                <li><b>Payer Email:</b> {orderDetails?.payerEmail}</li>
                <li><b>Payer Name:</b> {orderDetails?.payerFullName}</li>
                <li><b>Merchant Name:</b> {orderDetails?.payeeBrandName}</li>
                <li><b>PaymentGateway:</b> {orderDetails?.paymentGateway}</li>
              </ul>
            </div>
          </>
        ) : (
          <>
            <img src="/assets/icons/red-cross-icon.svg" alt="failed" className="w-24 h-24 mb-4" />
            <h1 className="text-2xl font-semibold text-red-600"> Payment Failed </h1>
            <p className="mt-2 text-gray-600"> Something went wrong with your transaction. Please try again. </p>
          </>
        )}
      <button onClick={() => navigate('/dashboard')} className="mt-6 p-2 border border-primary primary rounded-lg">Go to Dashboard</button>
    </div>
  );
};

export default PaymentVerify;
